import { render, staticRenderFns } from "./TableUsuarios.vue?vue&type=template&id=06e73cf0"
import script from "./TableUsuarios.vue?vue&type=script&lang=js"
export * from "./TableUsuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports